import { render, staticRenderFns } from "./checkStudent.vue?vue&type=template&id=776bc41e&scoped=true&"
import script from "./checkStudent.vue?vue&type=script&lang=js&"
export * from "./checkStudent.vue?vue&type=script&lang=js&"
import style0 from "./checkStudent.vue?vue&type=style&index=0&id=776bc41e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776bc41e",
  null
  
)

export default component.exports